import { render, staticRenderFns } from "./CreditTabs.vue?vue&type=template&id=0ce50f74&"
import script from "./CreditTabs.vue?vue&type=script&lang=js&"
export * from "./CreditTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports